import React, { Component } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Login from "./Screens/login/Login";
import AnnualReport from "./Screens/login/AnnualReport";
import {  ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductsListing from "./Screens/login/ProductsListing";
import MiflInnerPage from "./Screens/product-inner-page/Mifl";
import MildacInnerPage from "./Screens/product-inner-page/Mildac";

class App extends Component {
  render() {
    return (
<>
<ToastContainer
        limit={1}
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/annual-report" element={<AnnualReport />} />
          <Route path=":org">
            <Route path="products" element={<ProductsListing page={'mifl'}/>} />
            <Route path="Info/:id/:type" element={<MiflInnerPage />} />
          </Route>
          <Route path="mildac">
            <Route path=":region/products" element={<ProductsListing page={'mildac'}/>} />
            <Route path=":region/Info/:productCode" element={<MildacInnerPage />} />
          </Route>
        </Routes>
      </Router>

</>
    );
  }
}

export default App;
